module.exports = __webpack_public_path__ + "img/2 (8).0014c50e.jpg";